import { render, staticRenderFns } from "./VxCalendarIcon.vue?vue&type=template&id=e3b61434&scoped=true"
import script from "./VxCalendarIcon.vue?vue&type=script&lang=js"
export * from "./VxCalendarIcon.vue?vue&type=script&lang=js"
import style0 from "./VxCalendarIcon.vue?vue&type=style&index=0&id=e3b61434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b61434",
  null
  
)

export default component.exports